import { Checkbox, Field } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let ResultsReportOptionsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection single heading="Report">
    <Field input={<Checkbox />} name="Results.ReportSizeOfTestPortion" />
    <Field input={<Checkbox />} name="Results.ReportPSDCurveAnalysis" />
  </ListFieldSection>
);

ResultsReportOptionsSection = withInjectedProps(ResultsReportOptionsSection);

export { ResultsReportOptionsSection };
export default ResultsReportOptionsSection;
